
//1. For import syntax
export default class Utils{
    constructor(){
        circunstancias_especiales=[
            {check:false,nombre:'Separación de padres'},
            {check:false,nombre:'Fallecimientos'},
            {check:false,nombre:'Mudanzas'},
            {check:false,nombre:'Factor socio-económico'},
            {check:false,nombre:'Llegada de nuevo hermano (a)'},
            {check:false,nombre:'Cambios en su rutina'}
        ];
    } 
   
}








// WEBPACK FOOTER //
// ./src/models/FormatoUtils.js